export default {"src":"/_next/static/image/public/logos/ftx-icon.e1bbe7ca76969c318cc54971c3c44d22.svg","height":290,"width":858};